export const ToastErrorIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM11.207 4.79395C10.9114 4.49834 10.4313 4.49834 10.1357 4.79395L8 6.92969L5.86426 4.79395C5.56866 4.49834 5.08857 4.49834 4.79297 4.79395C4.49771 5.08952 4.49762 5.56874 4.79297 5.86426L6.92969 8L4.79297 10.1367C4.49765 10.4323 4.49769 10.9115 4.79297 11.207C5.08857 11.5026 5.56866 11.5026 5.86426 11.207L8 9.07129L10.1357 11.207C10.4313 11.5026 10.9114 11.5026 11.207 11.207C11.5024 10.9115 11.5024 10.4323 11.207 10.1367L9.07129 8L11.207 5.86426C11.5025 5.56873 11.5024 5.08953 11.207 4.79395Z"
        fill="#F33F5D"
      />
    </svg>
  )
}
